import React from 'react';
import { View } from 'react-native';
import { useRoute, type RouteProp } from '@react-navigation/native';
import { Button, Text } from '~/components';
import type { RootStackParamList } from '~/navigation/types';

import OInsuranceSVG from '~/assets/svgs/o-insurance-logo.svg';
import Step from './components/Step';
import { Components } from '../../../components';
import useAppNavigation from '~/hooks/useAppNavigation';
import { callNumber } from '~/utils/device';
import DefaultContainer from '../../components/DefaultContainer';
import { useUserInfoStore } from '~/stores/userInfo';
import AlertSVG from '~/assets/svgs/alert.svg';
import PhoneSVG from '~/assets/svgs/phone.svg';
import HeadsetSVG from '~/assets/svgs/headset.svg';

const SINISTER_PHONE = '3003-0335';
const O_INSURANCE_CAPITAL_PHONE = '(11) 4002-6542';
const O_INSURANCE_OTHERS_PHONE = '0800-568-6333';

const HiredInsuranceSinisterAuto: React.FC = () => {
  const { goBack } = useAppNavigation();
  const contractedServices = useUserInfoStore(
    (state) => state.user?.contractedServices
  );

  const {
    params: { id: certificateCode },
  } =
    useRoute<
      RouteProp<RootStackParamList, 'MarisaServicos_HiredInsuranceSinisterAuto'>
    >();

  const contractedService = contractedServices?.find(
    (service) => service.certificateCode === certificateCode
  );

  if (!contractedService) return null;

  return (
    <DefaultContainer type="marisa-auto" className="pt-6 pb-12">
      <Text className="text-lg font-medium text-gray-600 mb-5">
        Comunicação de Sinistro
      </Text>

      <Text className="text-xs font-medium text-primary-600">
        Atenção segurado
      </Text>

      <Text className="text-sm text-gray-400 mt-6">
        Estamos aqui pra te ajudar em qualquer circunstância de sinistro de
        roubo e furto.
      </Text>

      <Text className="text-sm text-gray-400 my-4">
        Se esse for o seu caso, siga os passos abaixo. Caso queira informar
        Aviso de Sinistro Terceiro ou PT por colisão ou danos comunique a
        atendente na central de atendimento.
      </Text>

      <Text className="text-sm text-gray-400 mb-8">
        Sabemos que qualquer pessoa pode se envolver em uma situação que cause
        prejuízos ou danos ao veículo. Por isso nós estamos aqui para te ajudar
        em qualquer circunstância de sinistro. Se esse for o seu caso, faça o
        seguinte:
      </Text>

      <Step icon={AlertSVG} title="Atenção">
        Tente manter a calma e nunca reaja em caso de assalto.
      </Step>

      <Step icon={PhoneSVG} title="Acione por telefone">
        Procure um lugar seguro e ligue para nós:{' '}
        <Text
          className="text-primary-600 font-medium"
          onPress={() => callNumber(SINISTER_PHONE)}
        >
          {SINISTER_PHONE}
        </Text>{' '}
        e digite a{' '}
        <Text className="text-primary-600 font-medium">opção 2 no menu</Text>.
      </Step>

      <Step icon={HeadsetSVG} title="Atendimento">
        Um atendente estará de prontidão para te ajudar. Qualquer dia da semana,
        a qualquer horário.
      </Step>

      <Components.Divider />

      <Components.InsurancePolicyInfo
        policyNumber={contractedService.policyNumber}
        policyUrl={contractedService.policyUrl}
      />

      <Components.Divider />

      <Text className="text-lg font-medium">Contato da administradora</Text>

      <View className="mt-6 rounded-2xl p-6 bg-gray-100">
        <OInsuranceSVG />

        <Text className="mt-4 text-xs text-gray-500">
          Capital:{' '}
          <Text
            className="text-primary-600 font-medium"
            onPress={() => callNumber(O_INSURANCE_CAPITAL_PHONE)}
          >
            {O_INSURANCE_CAPITAL_PHONE}
          </Text>
        </Text>

        <Text className="text-xs text-gray-500 mb-3">
          Demais:{' '}
          <Text
            className="text-primary-600 font-medium"
            onPress={() => callNumber(O_INSURANCE_OTHERS_PHONE)}
          >
            {O_INSURANCE_OTHERS_PHONE}
          </Text>
        </Text>

        <Text className="text-xs text-gray-500">
          Segunda a sábado: 08:00 - 22:00
        </Text>
        <Text className="text-xs text-gray-500">
          Domingos e feriados: 12:00 - 20:00
        </Text>
      </View>

      <Button variant="tertiary" className="mt-6" onPress={goBack}>
        VOLTAR
      </Button>
    </DefaultContainer>
  );
};

export default HiredInsuranceSinisterAuto;
